import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
// import { LoginService } from '../../login/login.service';
// import { LoginSettings } from '../../login/LoginSetting.model';
import { Report } from '../models/report.model';
import { ReportFolder } from '../models/report-folder.model';
// import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { CheckForErrorsMessageComponent } from '../../../shared-components/guards/check-for-errors/check-for-errors-message/check-for-errors-message.component';
import { ReportParametersComponent } from '../parameters/report-parameters.component';
import { System } from '../../../shared-components/System';
import { ReportAutoRunMessageComponent } from './report-autorun-message.component';

@AutoUnsubscribe()
@Component({
    selector: 'reportSettings',
    templateUrl: './report-settings.folders.component.html',
    styleUrls: ['./report-settings.folders.component.css']

    // entryComponents: [
    //     ReportParametersComponent
    //     ]
})

export class ReportSettingsFoldersComponent implements OnInit, OnDestroy {
    @ViewChild(ReportAutoRunMessageComponent) myReportAutoRunMessageComponent: ReportAutoRunMessageComponent;

    thisDialogRef: MatDialogRef<ReportSettingsFoldersComponent>;

    // loginSettings: LoginSettings;
    allowAutoRunReport: boolean;
    reportFolders: ReportFolder[] = [];
    // //ReportParameters: ReportParameter[]; //??

    selectedReport: Report;
    // reportSettingsDialogRef: MatDialogRef<ReportSettingsComponent>;

    reportsMode: number; // enum: MyReports = 1, AllReports = 2
    foldersChkAll: boolean;
    noFolderSelected: boolean;
    isChecked: boolean;
    inDebugMode: boolean;
    MaximumSnapshots: number;

    reportParametersDialogRef: MatDialogRef<ReportParametersComponent>;
    isDirty: boolean;
    onLoad_FolderIds: number[] = [];
    current_FolderIds: number[] = [];
    reportAutoRunMessageDialogRef: MatDialogRef<ReportAutoRunMessageComponent>;

    constructor(
        reportSettingsDialogRef: MatDialogRef<ReportSettingsFoldersComponent>,
        private reportService: ReportingService,
        // private myReportsComponent: MyReportsComponent
        // private loginService: LoginService,
        private dialog: MatDialog,
        private reportParametersDialog: MatDialog,
        private reportAutoRunMessageDialog: MatDialog,

    ) {

        this.thisDialogRef = reportSettingsDialogRef;
        this.selectedReport = reportService.SelectedReport;
        this.reportFolders = reportService.ReportFolders;
        // this.allowAutoRunReport = this.loginService.LoginSettings.AllowAutoRunReport;
        // this.loginSettings = loginService.LoginSettings;
        this.allowAutoRunReport = this.reportService.allowAutoRunReport;
        this.inDebugMode = reportService.inDebugMode;
        // https://fdvm1sisapp1.tylertech.com/ClientTierN/AppApi/TylerSis/Student/GetReportParameters?userId=72646&paramId=-1&ayIdentifier=1819&schoolId=10&forSchedule=true
        // https://fdvm1sisapp1.tylertech.com/ClientTierN/AppApi/TylerSis/Student/GetReportParameters?userId=72646&paramId=-1&ayIdentifier=1819&schoolId=10&forSchedule=true


    }

    ngOnInit() {
        // call getMyReportFolders() conditionally somehow?
        // only needs called if change made in all reports
        // this.getMyReportFolders();
        // this.reportFolders = this.reportService.ReportFolders;
        this.isDirty = false;

        if (this.inDebugMode) {
            console.log(this.reportFolders);
            console.log(this.reportService.ReportFolders);
        }

        this.reportService.isForSchedule = true;

        // if (this.selectedReport.AutoRunDate == '0001-01-01T00:00:00') {
        //     this.selectedReport.AutoRunDate = '11/6/2018';
        // }

        let reportIsInAllFolders = false;
        let reportIsInThisFolder = false;
        let folderCount = 0;

        for (let f = 0; f < this.reportFolders.length; f++) {
            for (let r = 0; r < this.reportFolders[f].Reports.length; r++) {
                if (this.reportFolders[f].Reports[r].Id == this.selectedReport.Id) {
                    this.reportFolders[f].ReportInFolder = true;
                    reportIsInThisFolder = true;
                    folderCount += 1;
                    break;
                }
                else {
                    this.reportFolders[f].ReportInFolder = false;
                    reportIsInThisFolder = false;
                }
            }
        }
        if (folderCount == this.reportFolders.length) {
            reportIsInAllFolders = true;
            this.foldersChkAll = true;
            this.noFolderSelected = false;
        }
        else {
            this.foldersChkAll = false;
        }
        if (folderCount == 0) {
            this.noFolderSelected = true;
        }

        if (this.inDebugMode) {
            console.log(this.reportFolders);
            console.log('foldersChkAll:');
            console.log(this.foldersChkAll);
            console.log('folderCount');
            console.log(folderCount);
        }

        if (this.reportService.inDebugMode) {
            console.log(this.selectedReport);
            console.log(this.reportFolders);

            // this.loginService.MaximumSnapshots

        }

        this.MaximumSnapshots = this.reportService.maxReportSnapshotAllowed;

        this.setSelectedFolders();
        this.getReportParameters();
    }

    ngOnDestroy() {

        this.reportService.isForSchedule = false;
    }

    getMyReportFolders(): void {
        this.reportService.getMyReportFolders().subscribe(reportFolders => {
            this.reportFolders = reportFolders;
            this.reportService.ReportFolders = this.reportFolders;
            //  this.showNoFoldersMessage = this.reportService.showNoFoldersMessage;
        });
    }


    openAutorunDefaultParametersDialog() {
        this.reportParametersDialogRef = this.reportParametersDialog.open(ReportParametersComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        // this.reportsDialogRef.beforeClose().subscribe(result => {
        //  console.log('shared/HeaderComponent =>reportsDialogRef.beforeClose()');
        // });


        this.reportParametersDialogRef.afterClosed().subscribe(result => {
            this.reportService.SelectedReport = null;
            this.reportService.autoRunSnapshot = null;
            this.reportService.isForSchedule = false;

            if (this.reportService.inDebugMode) {

            }
        });
    }

    // openReportParametersWindow() {



    // }

    getReportParameters() {
        // todo: forschedule = true!!!
        this.reportService.getReportParameters(-1, this.selectedReport, true).subscribe(report => {
            // GetReportParameters?userId=72646&paramId=-1&ayIdentifier=1819&schoolId=10&forSchedule=true
            if (this.reportService.inDebugMode) {
                console.log(report);
            }

            this.selectedReport = report;
            this.reportService.SelectedReport = report;
            // this.openReportParametersWindow();

        });
    }

    SelectedReportToConsole() {
        console.log(this.selectedReport);
    }

    saveClick() {
        const selectedFolderIds: number[] = [];
        for (let i = 0; i < this.reportFolders.length; i++) {
            if (this.reportFolders[i].ReportInFolder) {
                selectedFolderIds.push(this.reportFolders[i].Id);
            }
        }

        this.reportService.selectedFolderIds = selectedFolderIds;
        

        if (this.reportService.inDebugMode) {
            console.log('saveClick()');
            console.log(selectedFolderIds);
        }

        // if autorun is turned on, do not allow remove from folder
        if (this.selectedReport.AutoRun == 'Y' && selectedFolderIds.length < 1) {
            //pop up message and block save action
            this.reportAutoRunMessageDialogRef = this.reportAutoRunMessageDialog.open(ReportAutoRunMessageComponent, {
                panelClass: 'tyl-mat-dialog',
                disableClose: true
              });
              return;
        }

        this.saveFolderReports(selectedFolderIds);

        // void SaveFolderReports(int loginId, int reportId, System.Collections.Generic.List<int> folderIds);

    }

    saveFolderReports(selectedFolderIds: number[]) {

        // first we need to save auto run settings
        this.reportService.saveReportAutoRunSettings().subscribe(res => {

            // now we need to save the report folders
            this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
                this.thisDialogRef.close('Folders Saved');
            });

        });


        // this.reportService.saveFolderReports(this.reportService.login_ID, this.selectedReport.Id, selectedFolderIds).subscribe(results => {
        //     this.thisDialogRef.close('Folders Saved');
        // });

    }



    /*

    SaveReportAutoRunSettings(int loginId, Sis.OneSis.Client.UI.Portal.StudentServices.ReportsDTO myReport)

        // Save Click
        $scope.SaveClick = function () {
            var selectedFolderIds = [];
            for (var i = 0; i < $scope.ReportFolders.length; i++) {
                if ($scope.ReportFolders[i].ReportInFolder)
                    selectedFolderIds.push($scope.ReportFolders[i].Id);
            }
            if ($scope.SelectedReportSettings.AutoRunReport) {
                $scope.validateFields();
                if ($scope.ReportSettingsErrorCount == 0) {
                    if ($scope.SelectedReportSettings.AutoRunFrequency == 0)
                        $scope.SelectedReportSettings.AutoRunTime = $scope.SelectedReportSettings.WeeklyTime;
                    else if ($scope.SelectedReportSettings.AutoRunFrequency == 1)
                        $scope.SelectedReportSettings.AutoRunTime = $scope.SelectedReportSettings.DailyTime;
                    else if ($scope.SelectedReportSettings.AutoRunFrequency == 2)
                        $scope.SelectedReportSettings.AutoRunTime = $scope.SelectedReportSettings.SingleTime;
                    $scope.SelectedReportSettings.AutoRunDate = $scope.AutoRunDate;
                }
            }

            if ($scope.ReportSettingsErrorCount == 0) {
                $scope.isReportsBusy = true;
                // Promise Chaining
                $q.all([sisService.saveFolderReports($scope.SelectedReportSettings.Id, selectedFolderIds), sisService.saveReportAutoRunSettings($scope.SelectedReportSettings)])
                    .then(function (results) {
                        $scope.isReportsBusy = false;
                        getMyReports(false);
                        $scope.getReportModules()
                    });
                $uibModalInstance.dismiss('Save was clicked.');
            }
        }
    */

    setSelectedFolders() {

        let reportIsInAllFolders = false;
        let reportIsInThisFolder = false;
        let folderCount = 0;
        for (let f = 0; f < this.reportFolders.length; f++) {
            for (let r = 0; r < this.reportFolders[f].Reports.length; r++) {
                if (this.reportFolders[f].Reports[r].Id == this.selectedReport.Id) {
                    this.reportFolders[f].ReportInFolder = true;
                    reportIsInThisFolder = true;
                    folderCount += 1;
                    break;
                }
            }
            if (!reportIsInThisFolder) {
                this.reportFolders[f].ReportInFolder = false;
            }
        }
        if (folderCount == this.reportFolders.length) {
            reportIsInAllFolders = true;
            this.foldersChkAll = true;
            this.noFolderSelected = false;
        }
        else {
            this.foldersChkAll = false;
        }
        if (folderCount == 0) {
            this.noFolderSelected = true;
        }


        for (let i = 0; i < this.reportFolders.length; i++) {
            if (this.reportFolders[i].ReportInFolder) {
                this.onLoad_FolderIds.push(this.reportFolders[i].Id);
            }
        }

        if (this.reportService.inDebugMode) {
            console.log(this.reportFolders);
            console.log('foldersChkAll:');
            console.log(this.foldersChkAll);
            console.log('folderCount');
            console.log(folderCount);
        }

    }


    cancelClick() {
        this.checkIsDirty();
        if (this.reportService.inDebugMode) {
            console.log('isDirty: ' + this.isDirty.toString());
        }

        if (this.isDirty) {

            const dialog = this.dialog.open(CheckForErrorsMessageComponent, {
                disableClose: true,
                data: {
                    errors: []
                }
            });

            dialog.componentInstance.dialogBox = dialog;
            dialog.afterClosed().subscribe(result => {
                console.log(result);
                switch (result) {
                    case 1: { // determine if edit or new folder > save and continue
                        this.saveClick();
                        break;
                    }
                    case 0: { // continue without save
                        this.thisDialogRef.close(false);
                        break;
                    }
                    case -1: { // cancel
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });

        }
        else { // no unsaved changes
            this.thisDialogRef.close();   // true to refreshFolders
        }
    }

    autoRunReportClick() {

    }


    checkAllFolders(foldersChkAll: boolean) {

        this.foldersChkAll = foldersChkAll; // this.isChecked;
        this.noFolderSelected = !foldersChkAll; // this.isChecked;

        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => checkAllFolders( ' + foldersChkAll + ')');
            console.log(this.reportFolders);
            console.log(this.foldersChkAll);
            console.log(this.noFolderSelected);
        }


        for (let i = 0; i < this.reportFolders.length; i++) {
            if (this.foldersChkAll) {
                this.reportFolders[i].ReportInFolder = true;
            }

            else {
                this.reportFolders[i].ReportInFolder = false;
            }

        }
        if (this.noFolderSelected == true) {
            this.selectedReport.AutoRunReport = false;
        }

        // if (this.reportService.inDebugMode) {
        //     console.log('ReportSettingsComponent => checkAllFolders( ' + foldersChkAll + ')');
        //     console.log(this.reportFolders);
        // }

    }

    chkFolder(folder: ReportFolder) {

        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => chkFolder( ' + folder + ')');
            console.log(this.reportFolders);
        }

        // this.setSelectedFolders();

        // this.noFolderSelected = true;
        let reportInFolderCount = 0;

        for (let x = 0; x < this.reportFolders.length; x++) {
            if (this.reportFolders[x].ReportInFolder == true) {
                reportInFolderCount += 1;
            }
        }


        if (reportInFolderCount < this.reportFolders.length) {
            this.foldersChkAll = false;
            return;
        }

        if (reportInFolderCount == this.reportFolders.length) {
            this.checkAllFolders(true);
            return;
        }

        if (reportInFolderCount == 0) {
            this.selectedReport.AutoRunReport = false;
            this.checkAllFolders(false);
            this.noFolderSelected = true;
            return;
        }

        // this.reportService.ReportFolders = this.reportFolders; // ??


        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => chkFolder( ' + folder + ')');
        }

    }

    setFrequency(frequency) {

        // this.selectedReport.AutoRunFrequency = frequency;
        if (this.reportService.inDebugMode) {
            console.log('ReportSettingsComponent => setFrequency( ' + frequency + ')');
        }
        this.selectedReport.AutoRunFrequency = frequency;
    }

    checkIsDirty() {

        for (let i = 0; i < this.reportFolders.length; i++) {
            if (this.reportFolders[i].ReportInFolder) {
                this.current_FolderIds.push(this.reportFolders[i].Id);
            }
        }

        if (System.isEqual(this.current_FolderIds, this.onLoad_FolderIds)) {

            this.isDirty = false;
        } else {
            this.isDirty = true;
        }

        if (this.reportService.inDebugMode) {
            console.log('checkIsDirty()');
            console.log(this.current_FolderIds);
            console.log(this.onLoad_FolderIds);
        }

    }

    // open(){
    //     // this.open = function ($event, index) {
    //     // $event.preventDefault();
    //     // $event.stopPropagation();
    //     // this.opened.forEach(function (item, index) { this.opened[index] = false; });
    //     // this.opened[index] = true;

    //     if (this.reportService.inDebugMode) {
    //         console.log('ReportSettingsComponent => open( ' + '' + ')');
    //     }
    // }


} // end class

